import * as React from 'react';
import { AppSetting } from 'dependencies/appsettings';
import { getConnectionTypesList } from '../../mapping/get-connection-types-list';
import { BowtieTranslation } from '../../constants';
import { BowtieCase, BowtieCaseOtherConnection, BowtieTooltipOptions, CaseRegistrationTemplate, DraftConnections } from '../../types';
import { ConnectedCasesState, InspectionEvaluations } from '../../types-store';
import { renderFieldFactory, renderLabelFactory } from './render-factory';
import { TooltipParser, TooltipSectionElement } from './tooltip-parser';
import { TooltipField } from './tooltip-field';
import { TooltipEvaluationsSection } from './tooltip-evaluations-section';
import { TooltipConnectedTable } from './tooltip-table';

import style from './tooltip-builder.scss';
import { BowtieMeatBallMenu } from 'app/area/bowtie/dropdown/bowtie-meatball-menu';
import { SEQUENCE_DIRECTION } from 'app/area/case/features/connected-cases/sequence';

interface TooltipBuilderProps {
  caseData: BowtieCase;
  draftData: BowtieCase;
  otherConnections: BowtieCaseOtherConnection[];
  draftConnections: DraftConnections[];
  connectedCases: ConnectedCasesState;
  loadConnectedCases: (caseNumber: number, caseType: number) => void;
  inspectionEvaluations: InspectionEvaluations;
  caseTemplate: CaseRegistrationTemplate;
  tooltipOptions: BowtieTooltipOptions;
  translation: BowtieTranslation;
  siblingCaseIds: number[];
  changeSequence: (direction: SEQUENCE_DIRECTION) => void;
  parentCaseId?: number;
  sequenceOrder: number[];
  bowtieOverlayRef?: React.RefObject<HTMLDivElement>;
  changeConnectionSequenceId?: number;
  stateForCaseIds: { [caseId: string]: { valid: boolean; fetching: boolean } };
}

export const TooltipBuilder: React.FC<TooltipBuilderProps> = (props) => {

  const { caseData, draftData, connectedCases, loadConnectedCases,
    otherConnections, draftConnections, inspectionEvaluations, caseTemplate,
    tooltipOptions, translation, siblingCaseIds, parentCaseId, changeSequence, sequenceOrder, bowtieOverlayRef, 
    changeConnectionSequenceId, stateForCaseIds } = props;

  const connectionTypes = getConnectionTypesList(caseData.caseNumber, otherConnections, draftConnections);

  const renderField = renderFieldFactory(AppSetting.ApplicationUrl);
  const renderLabel = renderLabelFactory(caseTemplate);

  const template = tooltipOptions.tooltipTemplate ? new TooltipParser().parse(tooltipOptions.tooltipTemplate) : [];
  const fieldTemplate = template.filter(templateField => typeof templateField === 'string') as string[];
  const connectedTemplates = template.filter(t => t instanceof TooltipSectionElement) as TooltipSectionElement[];
  return !!template && template.length > 0 && <div className={style.tooltip}>
    {fieldTemplate.map(templateField =>
      <TooltipField
        key={templateField}
        label={renderLabel(caseData, templateField)} >
        {renderField(caseData, templateField)}
      </TooltipField>
    )}
    {!!tooltipOptions.showEvaluations && <TooltipEvaluationsSection
      caseNumber={caseData.caseNumber}
      inspectionEvaluations={inspectionEvaluations}
      translation={translation} />}
    {!!tooltipOptions.showConnections &&
      <TooltipConnectedTable
        caseNumber={caseData.caseNumber}
        connectionTypes={connectionTypes}
        draftData={draftData}
        connectedCases={connectedCases}
        loadConnectedCases={loadConnectedCases}
        renderField={renderField}
        renderLabel={renderLabel}
        templates={connectedTemplates}
        applicationUrl={AppSetting.ApplicationUrl}
        translation={translation} />}
        <BowtieMeatBallMenu 
          caseId={caseData?.caseNumber} 
          translation={translation} 
          siblingCaseIds={siblingCaseIds} 
          changeSequence={tooltipOptions.showChangeSequenceOptions ? changeSequence : null}
          parentCaseId={parentCaseId}
          sequenceOrder={sequenceOrder}
          showChangeSequenceOptions={tooltipOptions.showChangeSequenceOptions}
          bowtieOverlayRef={bowtieOverlayRef} 
          changeConnectionSequenceId={changeConnectionSequenceId}
          stateForCaseIds={stateForCaseIds}
        />
  </div>;
};
